export enum Selector {
  Drillhole = 'Drillhole',
  Ring = 'Ring',
  Project = 'Project',
  Organization = 'Organization',
  Partners = 'Partners',
  Admin = 'Admin',
}

export enum SelectorValue {
  Drillhole = 10,
  Ring = 15,
  Project = 20,
  Organization = 30,
  Partners = 40,
  Admin = 50,
}

export enum ScopeType {
  Survey = 'Survey',
  Drillhole = 'Drillhole',
  Ring = 'Ring',
  Project = 'Project',
  Organization = 'Organization',
}

export enum ScopeTypeValue {
  Survey = 5,
  Drillhole = 10,
  Ring = 15,
  Project = 20,
  Organization = 30,
}

export enum IdentityType {
  User = 'User',
  Group = 'Group',
}

export enum PermissionsConstants {
  CreatePartnerOrganization = 'CreatePartnerOrganization',
  DeletePartnerOrganization = 'DeletePartnerOrganization',
  ManageDefaultRoles = 'ManageDefaultRoles',
  ManagePermissions = 'ManagePermissions',
  CreateOrganization = 'CreateOrganization',
  DeleteOrganization = 'DeleteOrganization',
  BlockOrganization = 'BlockOrganization',
  ManageRoleAssignments = 'ManageRoleAssignments',
  ManageOrganizationRoleAssignments = 'ManageOrganizationRoleAssignments',
  ManageLicenses = 'ManageLicenses',
  ManageGlobalLicenses = 'ManageGlobalLicenses',
  ManageOrganizationInfo = 'ManageOrganizationInfo',
  ManagePartnerOrganization = 'ManagePartnerOrganization',
  ManageAdminOrganization = 'ManageAdminOrganization',
  ManageUsers = 'ManageUsers',
  ManageRoles = 'ManageRoles',
  ManageGroups = 'ManageGroups',
  ManageUnitSystems = 'ManageUnitSystems',
  ManageRecycleBin = 'ManageRecycleBin',
  ManageQuarantine = 'ManageQuarantine',
  CreateProject = 'CreateProject',
  ManageProjectInfo = 'ManageProjectInfo',
  DeleteProject = 'DeleteProject',
  ManageProjectRoleAssignments = 'ManageProjectRoleAssignments',
  CreateDrillhole = 'CreateDrillhole',
  CreateRingDrillhole = 'CreateRingDrillhole',
  ManageDrillholeInfo = 'ManageDrillholeInfo',
  DeleteDrillhole = 'DeleteDrillhole',
  ManageDrillholeRoleAssignments = 'ManageDrillholeRoleAssignments',
  ManageSurveys = 'ManageSurveys',
  UseStructMaster = 'UseStructMaster',
  ApproveLicenses = 'ApproveLicenses',
}

export enum Country {
  'Afghanistan' = 'Afghanistan',
  'Albania' = 'Albania',
  'Algeria' = 'Algeria',
  'Andorra' = 'Andorra',
  'Angola' = 'Angola',
  'Antigua and Barbuda' = 'Antigua and Barbuda',
  'Argentina' = 'Argentina',
  'Armenia' = 'Armenia',
  'Australia' = 'Australia',
  'Austria' = 'Austria',
  'Azerbaijan' = 'Azerbaijan',
  'Bahamas' = 'Bahamas',
  'Bahrain' = 'Bahrain',
  'Bangladesh' = 'Bangladesh',
  'Barbados' = 'Barbados',
  'Belarus' = 'Belarus',
  'Belgium' = 'Belgium',
  'Belize' = 'Belize',
  'Benin' = 'Benin',
  'Bhutan' = 'Bhutan',
  'Bolivia' = 'Bolivia',
  'Bosnia and Herzegovina' = 'Bosnia and Herzegovina',
  'Botswana' = 'Botswana',
  'Brazil' = 'Brazil',
  'Brunei' = 'Brunei',
  'Bulgaria' = 'Bulgaria',
  'Burkina Faso' = 'Burkina Faso',
  'Burundi' = 'Burundi',
  'Cambodia' = 'Cambodia',
  'Cameroon' = 'Cameroon',
  'Canada' = 'Canada',
  'Cape Verde' = 'Cape Verde',
  'Central African Republic' = 'Central African Republic',
  'Chad' = 'Chad',
  'Chile' = 'Chile',
  'China' = 'China',
  'Colombia' = 'Colombia',
  'Comoros' = 'Comoros',
  'Costa Rica' = 'Costa Rica',
  'Côte d’Ivoire' = 'Côte d’Ivoire',
  'Croatia' = 'Croatia',
  'Cuba' = 'Cuba',
  'Cyprus' = 'Cyprus',
  'Czech Republic' = 'Czech Republic',
  'Democratic Republic of the Congo' = 'Democratic Republic of the Congo',
  'Denmark' = 'Denmark',
  'Djibouti' = 'Djibouti',
  'Dominica' = 'Dominica',
  'Dominican Republic' = 'Dominican Republic',
  'East Timor' = 'East Timor',
  'Ecuador' = 'Ecuador',
  'Egypt' = 'Egypt',
  'El Salvador' = 'El Salvador',
  'Equatorial Guinea' = 'Equatorial Guinea',
  'Eritrea' = 'Eritrea',
  'Estonia' = 'Estonia',
  'Ethiopia' = 'Ethiopia',
  'Fiji' = 'Fiji',
  'Finland' = 'Finland',
  'France' = 'France',
  'Gabon' = 'Gabon',
  'Gambia' = 'Gambia',
  'Georgia' = 'Georgia',
  'Germany' = 'Germany',
  'Ghana' = 'Ghana',
  'Greece' = 'Greece',
  'Grenada' = 'Grenada',
  'Guatemala' = 'Guatemala',
  'Guinea' = 'Guinea',
  'Guinea-Bissau' = 'Guinea-Bissau',
  'Guyana' = 'Guyana',
  'Haiti' = 'Haiti',
  'Honduras' = 'Honduras',
  'Hungary' = 'Hungary',
  'Iceland' = 'Iceland',
  'India' = 'India',
  'Indonesia' = 'Indonesia',
  'Iran' = 'Iran',
  'Iraq' = 'Iraq',
  'Ireland' = 'Ireland',
  'Israel' = 'Israel',
  'Italy' = 'Italy',
  'Jamaica' = 'Jamaica',
  'Japan' = 'Japan',
  'Jordan' = 'Jordan',
  'Kazakhstan' = 'Kazakhstan',
  'Kenya' = 'Kenya',
  'Kiribati' = 'Kiribati',
  'Kuwait' = 'Kuwait',
  'Kyrgyzstan' = 'Kyrgyzstan',
  'Laos' = 'Laos',
  'Latvia' = 'Latvia',
  'Lebanon' = 'Lebanon',
  'Lesotho' = 'Lesotho',
  'Liberia' = 'Liberia',
  'Libya' = 'Libya',
  'Liechtenstein' = 'Liechtenstein',
  'Lithuania' = 'Lithuania',
  'Luxembourg' = 'Luxembourg',
  'Madagascar' = 'Madagascar',
  'Malawi' = 'Malawi',
  'Malaysia' = 'Malaysia',
  'Maldives' = 'Maldives',
  'Mali' = 'Mali',
  'Malta' = 'Malta',
  'Marshall Islands' = 'Marshall Islands',
  'Mauritania' = 'Mauritania',
  'Mauritius' = 'Mauritius',
  'Mexico' = 'Mexico',
  'Micronesia' = 'Micronesia',
  'Moldova' = 'Moldova',
  'Monaco' = 'Monaco',
  'Mongolia' = 'Mongolia',
  'Montenegro' = 'Montenegro',
  'Morocco' = 'Morocco',
  'Mozambique' = 'Mozambique',
  'Myanmar' = 'Myanmar',
  'Namibia' = 'Namibia',
  'Nauru' = 'Nauru',
  'Nepal' = 'Nepal',
  'Netherlands' = 'Netherlands',
  'New Zealand' = 'New Zealand',
  'Nicaragua' = 'Nicaragua',
  'Niger' = 'Niger',
  'Nigeria' = 'Nigeria',
  'North Korea' = 'North Korea',
  'Norway' = 'Norway',
  'Oman' = 'Oman',
  'Pakistan' = 'Pakistan',
  'Palau' = 'Palau',
  'Panama' = 'Panama',
  'Papua New Guinea' = 'Papua New Guinea',
  'Paraguay' = 'Paraguay',
  'Peru' = 'Peru',
  'Philippines' = 'Philippines',
  'Poland' = 'Poland',
  'Portugal' = 'Portugal',
  'Qatar' = 'Qatar',
  'Republic of the Congo' = 'Republic of the Congo',
  'Republic of Macedonia' = 'Republic of Macedonia',
  'Romania' = 'Romania',
  'Russia' = 'Russia',
  'Rwanda' = 'Rwanda',
  'Saint Kitts and Nevis' = 'Saint Kitts and Nevis',
  'Saint Lucia' = 'Saint Lucia',
  'Saint Vincent and the Grenadines' = 'Saint Vincent and the Grenadines',
  'Samoa' = 'Samoa',
  'San Marino' = 'San Marino',
  'Sao Tome and Principe' = 'Sao Tome and Principe',
  'Saudi Arabia' = 'Saudi Arabia',
  'Senegal' = 'Senegal',
  'Serbia' = 'Serbia',
  'Seychelles' = 'Seychelles',
  'Sierra Leone' = 'Sierra Leone',
  'Singapore' = 'Singapore',
  'Slovakia' = 'Slovakia',
  'Slovenia' = 'Slovenia',
  'Solomon Islands' = 'Solomon Islands',
  'Somalia' = 'Somalia',
  'South Africa' = 'South Africa',
  'South Korea' = 'South Korea',
  'South Sudan' = 'South Sudan',
  'Spain' = 'Spain',
  'Sri Lanka' = 'Sri Lanka',
  'Sudan' = 'Sudan',
  'Suriname' = 'Suriname',
  'Swaziland' = 'Swaziland',
  'Sweden' = 'Sweden',
  'Switzerland' = 'Switzerland',
  'Syria' = 'Syria',
  'Tajikistan' = 'Tajikistan',
  'Tanzania' = 'Tanzania',
  'Thailand' = 'Thailand',
  'Togo' = 'Togo',
  'Tonga' = 'Tonga',
  'Trinidad and Tobago' = 'Trinidad and Tobago',
  'Tunisia' = 'Tunisia',
  'Turkey' = 'Turkey',
  'Turkmenistan' = 'Turkmenistan',
  'Tuvalu' = 'Tuvalu',
  'Uganda' = 'Uganda',
  'Ukraine' = 'Ukraine',
  'United Arab Emirates' = 'United Arab Emirates',
  'United Kingdom' = 'United Kingdom',
  'United States of America' = 'United States of America',
  'Uruguay' = 'Uruguay',
  'Uzbekistan' = 'Uzbekistan',
  'Vanuatu' = 'Vanuatu',
  'Venezuela' = 'Venezuela',
  'Vietnam' = 'Vietnam',
  'Yemen' = 'Yemen',
  'Zambia' = 'Zambia',
  'Zimbabwe' = 'Zimbabwe',
}

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
